import { useMutation } from '@tanstack/react-query';

import { useEditCanvasStore } from '@air/feature-edit-canvas';

import { usePrivateCanvasesDuplicateCanvasMutation } from '~/swr-hooks/canvases/usePrivateCanvasesDuplicateCanvasMutation';

const DUPLICATE_CANVAS_TITLE_PREFIX = 'Copy of ';

export type UseDuplicateCanvasMutationParams = {
  workspaceId: string;
  canvasId: string;
};

export const useDuplicateCanvasMutation = () => {
  const { mutateAsync: duplicateCanvas } = usePrivateCanvasesDuplicateCanvasMutation();

  return useMutation({
    mutationFn: async ({ workspaceId, canvasId }: UseDuplicateCanvasMutationParams) => {
      // Canvas edits sync to the backend on a debounce, so duplicating server-side without
      // flushing first copies a stale, pre-flush snapshot. flushSync is only registered while
      // the canvas editor is mounted; when it is absent there is no pending queue to flush.
      await useEditCanvasStore.getState().flushSync?.();

      return duplicateCanvas({ workspaceId, canvasId, prefix: DUPLICATE_CANVAS_TITLE_PREFIX });
    },
  });
};
